export default __webpack_public_path__ + "static/media/bid-now-upgrades.bbfee5b3.svg";